import React from 'react';
import styled from '@emotion/styled';
import { PreviewProps } from '../LandingPagePreview';
import { MessageTemplateType } from '~/types/models';
import NextGen from './Mobile/NextGen';
import Postcard from './Mobile/Postcard';

const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 290px;
  margin: 0 auto;
  font-size: 18px;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  min-height: 500px;
`;

function Mobile(props: PreviewProps) {
  const { templateType, canAccessNextGenTemplate } = props;
  return (
    <Container>
      {(!canAccessNextGenTemplate ||
        templateType === MessageTemplateType.Postcard) && (
        <Postcard {...props} />
      )}
      {canAccessNextGenTemplate &&
        templateType === MessageTemplateType.NextGen && <NextGen {...props} />}
    </Container>
  );
}

export default Mobile;
